<template>
  <b-container fluid>
    <b-row>
      <b-col class="px-0">
        <draggable v-model="testTypes">
          <transition-group>
            <div
              v-for="(testType, index) in testTypes"
              :key="testType.id"
              :class="{
                'test-type': true,
                'active': isTestTypeSelected(testType)
              }"
              @click="$emit('select', testType)"
            >
              {{ index + 1 }} : {{ testType.name }}
            </div>
          </transition-group>
        </draggable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import draggable from 'vuedraggable'

  export default {
    name: "TestType",
    components: {
      draggable
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      testTypeSelected: {
        type: Object,
        default: () => null
      }
    },
    computed: {
      testTypes: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
    },
    methods: {
      isTestTypeSelected(testType) {
        if (!this.testTypeSelected)
          return false;
        return testType.id === this.testTypeSelected.id
      }
    }
  }
</script>

<style lang="scss" scoped>
  .test-type {
    padding: 1rem;
    cursor: pointer;
    text-align: left;
    &:hover {
      background: #dde9ee;
      transition: all 130ms ease-out;
    }

    &.active {
      background: #FB822B;
      color: white;
      transition: all 130ms ease-out;
    }
  }
</style>